import React from 'react';
import PropTypes from 'prop-types';
import './BatchInfo.css';

const BatchInfo = ({ generatedScripts }) => {
  const batchKeys = Object.keys(generatedScripts);
  if (batchKeys.length === 0) return null;
  return (
    <div className="batch-info">
      <h4>Batch Processing Information</h4>
      <div className="batch-grid">
        {batchKeys.map((batchKey, index) => (
          <div key={batchKey} className="batch-item">
            <span className="batch-number">Batch {index + 1}</span>
            <span className="batch-status">✅ Completed</span>
          </div>
        ))}
      </div>
    </div>
  );
};

BatchInfo.propTypes = {
  generatedScripts: PropTypes.object.isRequired
};

export default BatchInfo; 